import Categories from './Gategories';

export default Categories;
